import { render, staticRenderFns } from "./employeesDeductions.vue?vue&type=template&id=a1ebea34"
import script from "./employeesDeductions.vue?vue&type=script&lang=js"
export * from "./employeesDeductions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports